module.exports = __webpack_public_path__ + "34736292/img/upload-icon.9179ae4e.svg";